import { app } from '../../../../app';
import { Controller } from './paypal-confirmed.controller';

app.component('companySmsServicesPaypalConfirmed', {
    bindings: {
        payment: '<',
        settings: '<',
        token: '<',
    },
    controller: Controller,
    templateUrl: require('./paypal-confirmed.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/paypal-confirmed/paypal-confirmed.component.js